import type { JobPhase, SubcomponentType, GenerationType } from './types';

export const PHASE_COLORS: Record<JobPhase, string> = {
  'Queued': 'bg-yellow-100 text-yellow-800',
  'Generating': 'bg-purple-100 text-purple-800',
  'Ready': 'bg-green-100 text-green-800',
  'Applied': 'bg-indigo-100 text-indigo-800',
  'Follow-Up': 'bg-orange-100 text-orange-800',
  'Negotiation': 'bg-pink-100 text-pink-800',
  'Declined': 'bg-rose-100 text-rose-800',
  'Accepted': 'bg-emerald-100 text-emerald-800',
  'Skipped': 'bg-gray-100 text-gray-800',
  'Expired': 'bg-red-100 text-red-800',
  'Errored': 'bg-red-200 text-red-900',
  'Trash': 'bg-gray-300 text-gray-700',
};

export const SUBCOMPONENT_LABELS: Record<SubcomponentType, string> = {
  contact: 'Contacts',
  summary: 'Summary',
  highlights: 'Highlights',
  skills: 'Core Skills',
  experience: 'Experience',
  education: 'Education',
  awards: 'Awards',
  presentations: 'Presentations',
  publications: 'Publications',
  portfolios: 'Portfolios',
  coverletter: 'Cover Letter',
  elevatorpitch: 'Elevator Pitch',
};

export const SUBCOMPONENT_LABELS_LONG: Record<SubcomponentType, string> = {
  contact: 'Contacts',
  summary: 'Summary',
  highlights: 'Highlights',
  skills: 'Core Skills',
  experience: 'Experience',
  education: 'Education',
  awards: 'Awards',
  presentations: 'Presentations',
  publications: 'Publications',
  portfolios: 'Portfolios',
  coverletter: 'Cover Letter',
  elevatorpitch: 'Elevator Pitch',
};

export const GENERATION_TYPE_LABELS: Record<GenerationType, string> = {
  manual: 'Manual',
  embedding: 'AI (Match)',
  generate: 'AI (Generate)',
  omit: 'Omit',
};

export function getSectionLabel(component: SubcomponentType, sectionNames?: Record<string, string>): string {
  if (sectionNames && sectionNames[component]) {
    return sectionNames[component];
  }
  return SUBCOMPONENT_LABELS[component] || component;
}
